export default __webpack_public_path__ + "static/charities-7de26d0657aa039f98d6a1fde4233388.jpg";